import { Listy, Typography } from 'antd';
import { IDataRoom } from 'interfaces';
import classes from './ContactsTab.module.scss';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from 'store/hook';
import systemPages from 'helpers/pagesAndLocation';
import { setSelectedDataRoom, setUserAndRoomStatus } from 'store/slices/userDataSlice';
import { setFoldersForPermissions } from 'store/slices/dataPermissionsSlice';
import { setSelectedKeys } from 'store/slices/windowStateSlice';
import { fetchRoom } from 'store/reducers/roomsCreator';
import { fetchUserPermissions } from 'store/reducers/userDataCreator';
import { TFunction } from 'i18next';
import { setAllTagsDocuments } from 'store/slices/chatsSlice';
import { checkIsTariffEnded, checkIsAwaitingPayment } from 'helpers/tariffPayment';

type Props = {
  rooms: IDataRoom[];
  clearRedux: () => void;
  t: TFunction;
};

export default function CommonRooms({ rooms, clearRedux, t }: Props) {
  const { selectedKeys } = useAppSelector((state) => state.windowState);
  const { dataRoom, isLoadingRoom } = useAppSelector((state) => state.dataRoom);
  const { isLoadingUserPermissions, available_rooms } = useAppSelector((state) => state.userData);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onItemClick = async (item: IDataRoom) => {
    const room = available_rooms.find(({ id }) => id === item.id)!;
    let rightOption = room?.access_terms_status == 'waiting_for_approve' ? 'nda' : 'documents';
    const isLoading = isLoadingRoom || isLoadingUserPermissions;

    if ((dataRoom?.id !== room.id || systemPages.includes(selectedKeys[0])) && !isLoading) {
      clearRedux();
      dispatch(setAllTagsDocuments([]));
      dispatch(setUserAndRoomStatus(''));
      dispatch(setFoldersForPermissions([]));
      dispatch(setSelectedKeys([`${rightOption}`]));
      dispatch(setSelectedDataRoom(room));
      navigate(`/room/${room.custom_url || room.id}/${rightOption}`);

      // RETURNED BILLING
      if (checkIsTariffEnded(room)) {
        navigate(`/room/${room?.id}/endedTariff`);
        return;
      } else if (checkIsAwaitingPayment(room)) {
        navigate(`/room/${room?.id}/awaitingPayment`);
        return;
      }
      //

      await dispatch(fetchRoom({ id: room.id }));

      await dispatch(fetchUserPermissions({ idRoom: room.id }));
      dispatch(setUserAndRoomStatus('fulfilledDataRoom')); // были проблемы с обновлением ло статуса fulfilledDataRoom для этого в начале стоит setUserAndRoomStatus('')
      // navigate(`/room/${room.custom_url || room.id}/${rightOption}`);
    } else {
      navigate(`/room/${room.custom_url || room.id}/${rightOption}`);
    }
  };

  return (
    <>
      <div className={classes.common_length}>
        <b>
          {t('Users.HelperMenu.length')}: {rooms.length}
        </b>
      </div>

      <Listy
        items={rooms}
        rowKey='id'
        className={classes.common_list}
        itemRender={(item, index) => (
          <div
            key={item.id}
            onClick={() => onItemClick(item)}
            className={classes.common_item}
            style={{ cursor: 'pointer' }}
          >
            <Typography.Text>{index + 1}.</Typography.Text> {item.name}
          </div>
        )}
      />
    </>
  );
}
